const transaction = [
  {
    // 交易历史
    path: '/dealHistory',
    name: 'dealHistory',
    component: (resolve) => {
      return require(['@/views/deal/dealHistory/index'], resolve)
    },
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'TransactionHistory',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 交易详情
    path: '/dealDetails',
    name: 'dealDetails',
    component: (resolve) => {
      return require(['@/views/deal/dealHistory/desktop/detail.vue'], resolve)
    },
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'Transaction'
    }
  },
  {
    // 持仓订单
    path: '/holdOrder',
    name: 'holdOrder',
    component: (resolve) => require(['@/views/deal/holdOrder/index'], resolve),
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'OpenOrders',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 持仓订单详情
    path: '/holdOrderDetails',
    name: 'holdOrderDetails',
    component: (resolve) => {
      return require(['@/views/deal/holdOrder/desktop/detail.vue'], resolve)
    },
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'Transaction'
    }
  },
  {
    // 限价订单
    path: '/limitOrder',
    name: 'limitOrder',
    component: (resolve) => require(['@/views/deal/limitOrder/index'], resolve),
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'LimitOrder',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 限价订单详情
    path: '/limitOrderDetails',
    name: 'limitOrderDetails',
    component: (resolve) => require(['@/views/deal/limitOrder/desktop/detail.vue'], resolve),
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'Transaction'
    }
  },
  {
    // 客户交易历史
    path: '/customerDealHistory',
    name: 'customerDealHistory',
    component: (resolve) => {
      return require(['@/views/deal/customer/dealHistory/index'], resolve)
    },
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'TransactionHistory',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户交易详情
    path: '/customerDealDetails',
    name: 'customerDealDetails',
    component: (resolve) => {
      return require(['@/views/deal/customer/dealHistory/desktop/detail.vue'], resolve)
    },
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'Transaction'
    }
  },
  {
    // 客户持仓订单
    path: '/customerHoldOrder',
    name: 'customerHoldOrder',
    component: (resolve) => require(['@/views//deal/customer/holdOrder/index'], resolve),
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'OpenOrders',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户持仓订单详情
    path: '/customerHoldOrderDetails',
    name: 'customerHoldOrderDetails',
    component: (resolve) => {
      return require(['@/views/deal/customer/holdOrder/desktop/detail.vue'], resolve)
    },
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'Transaction'
    }
  },
  {
    // 客户限价订单
    path: '/customerLimitOrder',
    name: 'customerLimitOrder',
    component: (resolve) => require(['@/views/deal/customer/limitOrder/index'], resolve),
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'LimitOrder',
      keepAlive: true,
      isPermission: true
    }
  },
  {
    // 客户限价订单详情
    path: '/customerLimitOrderDetails',
    name: 'customerLimitOrderDetails',
    component: (resolve) => require(['@/views/deal/customer/limitOrder/desktop/detail.vue'], resolve),
    meta: {
      crumbsOne: 'transaction',
      crumbsTow: 'Transaction'
    }
  }
]

export default transaction
